import React from 'react';
import {getColor, useStyles, getDate} from './helper';

const HistoryItem = ({item}) => {
    const {description, event_date, login, ip} = item;
    const color = getColor(description)
    const classes = useStyles({color});
    
    return (
        <div className={classes.root}>
            <span className={classes.date}>{getDate(event_date)}</span>
            <span>{login} ({ip})</span>
            <span className={classes.description}>{description}</span>
        </div>
    )
}

export default HistoryItem;